import React, { useMemo } from "react";
import Select from "react-select";
import { observer } from "mobx-react";
import { api } from "@/api";
import { useApiQuery } from "@/api/hooks/useApiQuery";
import { translations } from "@/constants/translations";
import { useStore } from "@/store";

interface Props {
  value?: string;
  onSelect: (value: string) => void;
  placeholder: string;
}

export const OrganizationTypeSelect = observer(
  ({ value, onSelect, placeholder }: Props) => {
    const { activeLanguage } = useStore();
    const commonLanguage = translations.common["organization-types"][
      activeLanguage
    ] as any;

    const organizationTypesQuery = useApiQuery({
      queryKey: ["organization-types"],
      queryFn: () => api.getOrganizationTypes(),
    });

    const options = useMemo(
      () =>
        (organizationTypesQuery.data || []).map((type) => ({
          label: commonLanguage[type] || type,
          value: type,
        })),
      [organizationTypesQuery.data, commonLanguage],
    );

    const fullValue = useMemo(
      () => (value ? { label: commonLanguage[value] || value, value } : null),
      [value, commonLanguage],
    );

    return (
      <Select
        classNamePrefix="select"
        isSearchable={false}
        isLoading={organizationTypesQuery.isLoading}
        options={options}
        onChange={(option: any) => onSelect(option?.value || "")}
        value={fullValue}
        placeholder={placeholder}
        styles={{
          container: (base) => ({
            ...base,
            width: "100%",
          }),
        }}
      />
    );
  },
);
